export type ShareTypeType = 'weibo' | 'facebook' | 'twitter' | 'telegram' | 'whatsapp';

export const shareTypeList: ShareTypeType[] = ['facebook', 'twitter', 'telegram', 'whatsapp'];
